import { useEffect, useRef, useState, useCallback } from 'react';

export const isPortraitMode = () =>
  window.matchMedia('(orientation: portrait)').matches;

export const getOrientation = () =>
  isPortraitMode() ? 'portrait' : 'landscape';

export function useOrientation(opts: {
  onPortrait?: () => void;
  onLandscape?: () => void;
}) {
  const { onPortrait, onLandscape } = opts;
  const orientation = getOrientation();
  const orientationRef = useRef(orientation);

  const [isPortrait, setIsPortrait] = useState(isPortraitMode());

  const onResize = useCallback(() => {
    if (getOrientation() === orientationRef.current) {
      return;
    }

    orientationRef.current = getOrientation();
    setIsPortrait(isPortraitMode());

    const callback = isPortraitMode() ? onPortrait : onLandscape;
    callback?.();
  }, [onPortrait, onLandscape]);

  useEffect(() => {
    window.addEventListener('resize', onResize);

    return () => window.removeEventListener('resize', onResize);
  }, [onResize]);

  useEffect(() => {
    if (!isPortraitMode()) {
      return;
    }
    onPortrait?.();
  }, [onPortrait]);

  return { isPortrait };
}

export const getRequestFullScreenKey = () => {
  let goFullScreen = 'requestFullscreen';
  if ('mozRequestFullScreen' in document.documentElement) {
    goFullScreen = 'mozRequestFullScreen';
  } else if ('webkitRequestFullscreen' in document.documentElement) {
    goFullScreen = 'webkitRequestFullscreen';
  } else if ('msRequestFullscreen' in document.documentElement) {
    goFullScreen = 'msRequestFullscreen';
  }
  return goFullScreen;
};
